import Select from 'react-select';
import styles from './SearchAndFilter.module.css';
import { FiSearch } from 'react-icons/fi';

interface FilterOption {
    value: string;
    label: string;
}

interface SearchAndFilterProps {
    filterList: FilterOption[];
}

function SearchAndFilter({ filterList }: SearchAndFilterProps) {

    const customStyles = {
        control: (provided: any, state: { isFocused: any; }) => ({
            ...provided,
            border: '1.5px solid #c9c9c9',
            boxShadow: state.isFocused ? '0 0 5px rgba(177, 172, 172, 0.43)' : 'none',
            '&:hover': {
                borderColor: '#c9c9c9',
            }
        }),
        option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#e6e6e6' : 'white',
            color: (state.isFocused || state.isSelected) ? 'black' : 'inherit',
            '&:hover': {
                backgroundColor: '#f3f3f3',
                color: 'black'
            }
        })

    };


    return(
        <div className={styles["container"]}>
            <div className={styles["search-container"]}>
                <FiSearch className={styles["icon-search"]} data-testid="icon-search" />
                <input type="search" className={styles.search} placeholder="Buscar" />
            </div>

            <Select options={filterList} className={styles.filter} styles={customStyles} id="searchInput" placeholder="Filtro" />

        </div>
    )
}

export default SearchAndFilter;